import { gql } from 'apollo-boost'

const SCRAPING_SESSION_STATISTICS = gql`
  query scrapingSessionStatistics($sessionId: ID!) {
    scrapingSessionStatistics(sessionId: $sessionId) {
      scrapingTestCaseResultCountByTag {
        type
        name
        outcome
        count
      }
      scrapingTestCaseResultCountByOutcome {
        outcome
        count
      }
    }
  }
`

export default SCRAPING_SESSION_STATISTICS
